import axios from 'axios';
import Constants from '../utils/Constants';

export const wafValidator = (t) => async (input) => {
    return axios.post(Constants.WAF_VALIDATION_URL, input)
        .then(() => Promise.resolve())
        .catch(() => Promise.reject(t('waf-validation')));
};

export function resolveValidity(validator, input, initialValidity) {
    if (input === null) {
        return toPromise(initialValidity);
    }

    return validate(validator, input);
}

function validate(validator, input) {
    const validationResult = validator(input);
    if (validationResult instanceof Promise) {
        return validationResult;
    } else if (validationResult !== null) {
        return Promise.reject(validationResult);
    }

    return Promise.resolve();
}

export function toPromise(validationState) {
    if (validationState instanceof Promise) {
        return validationState;
    } else {
        // validationState is the initial boolean state
        return validationState ? Promise.resolve() : Promise.reject();
    }
}

export const compositeValidator = (...validators) => (input) => {
    for (let i in validators) {
        const result = validators[i](input);
        if (result) {
            return result;
        }
    }

    return null;
};